module.exports = __webpack_public_path__ + "img/OverseaMember58.37dca216.jpg";